import type { AbilityDef } from "../../sim";

/** «Рывок»: → + △ — бросок через пол-экрана с ударом (кнопка + направление, без заучивания ввода). */
export const DASH_STRIKE: AbilityDef = {
  id: "dash-strike",
  name: "Рывок",
  input: { button: "heavyPunch", hold: "F" },
  pose: "dashStrike",
  startup: 10,
  active: 8,
  recovery: 18,
  actions: [{ frame: 3, type: "dash", params: { speed: 15 } }],
  hitbox: { x: 28, y: -124, w: 56, h: 32 },
  hit: { damage: 80, hitstun: 20, blockstun: 12, hitstop: 11, push: 8, height: "mid", chip: 8 },
  fx: { hit: "heavy/spark", block: "block/spark" },
  sound: { start: "whoosh", hit: "hit-heavy" },
};
